import axios from "axios";

const get = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/account/api/v1/nodes/group-me-bottom-dropdown")
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getBranchDropdown = {
  get
};

export default getBranchDropdown;
